import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ControllerBase } from 'src/app-client/_appCommon/base/ControllerBase';
import { UrlQueryDef } from 'src/app-client/_appCommon/base/UrlQueryDef';
import { OrderDataService } from 'src/app-client/_dataservices/OrderDataService';
import { ProductDataService } from 'src/app-client/_dataservices/ProductDataService';
import { GlobalConstants, PaymentType, PaymentTypeArray, ShowInSection } from 'src/app/_appCommon/base/AppInterfaceAndBaseClasses';

@Component({
  selector: 'app-checkout-pending-payment',
  templateUrl: './checkout-pending-payment.component.html',
  styleUrls: ['./checkout-pending-payment.component.css'],
  providers: [OrderDataService]
})
export class CheckoutPendingPaymentComponent extends ControllerBase {
  public paymentTypeArray: any
  public orderId: number;
  public order: any;
  public currentProduct: any;
  public paymentTypeSelected: PaymentType = null;
  public defaultImage = GlobalConstants.altProductImagePath;

  constructor(private orderDataService:OrderDataService,
    private router: Router,
    private productDataservice:ProductDataService,
    protected activatedRoute: ActivatedRoute) 
  { 

    super();
  }

  ngOnInit(): void {
    this.paymentTypeArray = PaymentTypeArray.filter(e=> (e.showIn == ShowInSection.Both || e.showIn == ShowInSection.Ecommerce) );
    this.activatedRoute.queryParamMap.subscribe(params =>
      {
        setTimeout(() =>
        {
          this.orderId = +params.get('orderId');
          this.orderDataService.getById(this.orderId,this.onGetQueryDefForGetById())
          .subscribe((response)=>
          {
            this.order = response; 
            this.productDataservice.getById(this.order.orderDetail[0].product.id)
            .subscribe((response)=>{
              this.currentProduct = response;
            })
          });

        });
      });

  }

  public onProcessPaymentType(): void
  {
    switch(this.paymentTypeSelected)
    {
      case PaymentType.OpenPay:
        this.router.navigate(['ecommerce/openpay'], {queryParams: {'orderId': this.orderId}});
        break;
      case PaymentType.PayNet:
        this.router.navigate(['ecommerce/paynet'],{queryParams: {'orderId': this.orderId}});
        break;
      case PaymentType.SPEI:
        this.router.navigate(['ecommerce/spei'],{queryParams: {'orderId': this.orderId}});
        break;
      case PaymentType.PayLink:
        this.router.navigate(['ecommerce/paylink'],{queryParams: {'orderId': this.orderId}});
        break;
      case PaymentType.CardPay:
        this.router.navigate(['ecommerce/cardpay'],{queryParams: {'orderId': this.orderId}});
        break;

      default:
        this.setInfoAlert("Selecciona un metodo de pago");
        break;
    }
    
  }

  protected onGetQueryDefForGetById()
  {
    let queryDef = new UrlQueryDef();
    queryDef.includes = "OrderDetail,OrderDetail.Product";
    return queryDef;
  }

  public getItemImage(images: any): string
  {
    return images.length > 0 ? images[0].url : this.defaultImage;
  }

}
